import { AnimatePresence, motion } from "framer-motion";
import { AlertTriangle } from "lucide-react"; 

export default function ModalLoginError({ errorEmail, setErrorEmail }) {
  return (
    <AnimatePresence>
      {errorEmail && (
        <motion.div
          key="modal-background"
          onClick={() => setErrorEmail(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4 text-center"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()} 
          >
            <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-4" /> 
            <h2 className="text-xl font-semibold mb-2 text-red-600">Error</h2>
            <p className="text-gray-600">
              Ha ocurrido un error. Te sugerimos intentarlo nuevamente en 30 minutos. Si el error persiste, contáctate con nosotros.
            </p>
            <button
              onClick={() => setErrorEmail(false)}
              className="mt-4 bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition-colors"
            >
              Cerrar
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}